import React, { Component } from 'react';
import { Container } from 'flux/utils';
import MembershipStore from '../../stores/MembershipStore';
import AvailableRolesStore from '../../stores/AvailableRolesStore';
import AvailableTableauUsersStore from '../../stores/AvailableTableauUsersStore';
import UserStore from '../../stores/UserStore';
import CurrentOrganizationStore from '../../stores/CurrentOrganizationStore';
import AdminActions from '../../actions/AdminActions';
import ManageUser from './ManageUser.react';

class ManageUserContainer extends Component {
  static getStores() {
    return [MembershipStore, UserStore, CurrentOrganizationStore, AvailableRolesStore];
  }

  static calculateState(prevState, props) {
    const org = CurrentOrganizationStore.getState();
    return {
      user: UserStore.get(+props.params.userId),
      organization: org,
      availableRoles: AvailableRolesStore.getState(),
      availableTableauUsers: AvailableTableauUsersStore.getState(),
      membership: MembershipStore.getMembership(+props.params.userId, org.id),
    };
  }

  componentDidMount() {
    AdminActions.requestUserData(this.props.params.userId);
  }

  render() {
    if (this.state.user && this.state.membership && this.state.availableRoles) {
      return (
        <ManageUser
          user={this.state.user}
          organization={this.state.organization}
          membership={this.state.membership}
          availableRoles={this.state.availableRoles}
          availableTableauUsers={this.state.availableTableauUsers}
        />);
    }
    return null;
  }
}

const container = Container.create(ManageUserContainer, { withProps: true });

export default container;
